import {
  call, put, select, takeLatest, takeEvery, all,
} from 'redux-saga/effects';
import findResult, { wildcardFilter } from '@/utils/resultsHelper';
import { removeUUIDsFromArray } from '@/utils/uuidHelper';
import selectors from '@/selectors';
import callAdapter from '@/utils/sagaHelper';
import { CARDS_PAGE_SIZE, presentationOptions } from '@/constants/states';
import VocabularyService from '../service';
import {
  showVocabularies,
  showVocabulariesError,
  editVocabulary,
  editVocabularyError,
  resetVocabularyError,
  resetVocabularySuccess,
} from '../actions';
import actions, { vocabularyGroupings, vocabularyLists } from '../constants';

export function* vocabularies(action) {
  const items = yield select(selectors.vocabularies);
  const {
    display, filter, pageSize, currentPage,
  } = items[action.category];
  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const { response, error } = yield call(callAdapter, VocabularyService.vocabularies(
    wildcardFilter(filter),
    page,
    display === presentationOptions.CARDS ? CARDS_PAGE_SIZE : size,
  ));

  if (error) {
    yield put(showVocabulariesError(action.category, error));
  } else {
    yield put(showVocabularies(
      action.category,
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
    ));
  }
}

export function* update() {
  const item = yield select(selectors.activeVocabulary);
  let { value } = item;
  if ([vocabularyGroupings.URLS, vocabularyGroupings.CUSTOM_LINKS].includes(item.grouping)) {
    value = JSON.stringify(removeUUIDsFromArray(item.urls));
  } else if ([vocabularyGroupings.EMAIL_TEMPLATE].includes(item.grouping)) {
    value = JSON.stringify(item.email);
  } else if ([vocabularyGroupings.ROLE_ACTIONS].includes(item.grouping)) {
    value = JSON.stringify(removeUUIDsFromArray(item.roleActions));
  }

  const { response, error } = yield call(callAdapter, VocabularyService.update({ code: item.code, value }));
  if (error) {
    yield put(editVocabularyError(error));
  } else {
    yield put(editVocabulary(item.code, response));
    yield all(vocabularyLists.map((category) => vocabularies({ category })));
  }
}

export function* reset({ category, code }) {
  const items = yield select(selectors.vocabularies);
  const { original, name } = findResult(items, category, code);
  const { response, error } = yield call(callAdapter, VocabularyService.update({ code, value: original }));

  if (error) {
    yield put(resetVocabularyError(code, category, name, error));
  } else {
    yield put(resetVocabularySuccess(code, category, response));
    yield all(vocabularyLists.map((c) => vocabularies({ category: c })));
  }
}

export function* refreshVocabulariesPresentation(action) {
  yield call(vocabularies, { ...action, page: 1, append: false });
}

export default function* vocabulariesApi() {
  yield takeEvery([actions.FETCH_VOCABULARIES, actions.REFRESH_VOCABULARIES], vocabularies);
  yield takeLatest(actions.UPDATE_VOCABULARY, update);
  yield takeEvery(actions.RESET_VOCABULARY, reset);
  yield takeEvery(actions.TOGGLE_VOCABULARIES_PRESENTATION, refreshVocabulariesPresentation);
}
